import { Page, Document, pdfjs } from 'react-pdf';
import { useState } from "react";
import styled from 'styled-components';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 16px);
    max-width: calc(100vw - 32px);
    background-color: #f5f5f5;
    padding: 8px 24px;
`;

const PdfWrapper = styled.div`
    background: white;
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 100%;

    .react-pdf__Document {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }

    .react-pdf__Page {
        max-width: 100%;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    }

    .react-pdf__Page__canvas {
        max-width: 100%;
        height: auto !important;
    }
`;

const LoadingText = styled.div`
    padding: 2rem;
    text-align: center;
    color: #666;
`;

const DownloadFab = styled.button`
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #1976d2;
    color: white;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    &:hover {
        background: #1565c0;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }
`;

const DownloadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
  </svg>
);

export const IzjavaOOdgovornosti = () => {
  const [numPages, setNumPages] = useState<number>();
  const izjavaUrl = window.location.hostname === 'localhost'
    ? 'https://cvv.amzs.si/media/IZJAVA_O_ODGOVORNOSTI.pdf'
    : '/media/IZJAVA_O_ODGOVORNOSTI.pdf';

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = izjavaUrl;
    link.download = 'IZJAVA_O_ODGOVORNOSTI.pdf';
    link.click();
  };

  return (
    <Container>
      <PdfWrapper>
        <Document
          file={izjavaUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<LoadingText>Loading PDF...</LoadingText>}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              width={1200}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              renderTextLayer={true}
              renderAnnotationLayer={true}
            />
          ))}
        </Document>
      </PdfWrapper>

      <DownloadFab onClick={handleDownload} aria-label="Download PDF">
        <DownloadIcon />
      </DownloadFab>
    </Container>
  );
};